<template>
	<div class="container">
			<div class="panel panel-default bjs">
				<div class="panel-footer  " style="font-size:12px">
					<a style="color: #626262; display:block;max-width:100%;padding:5px 5px;text-align:center;">版权声明 </a>
					<a style="color:#7e7d7d; display:block;max-width:100%;padding:5px 5px;text-align:left;text-indent:20px ">此网页展示内容，由各词条单位、采集工作组与有关文旅行政部门协助提供和整理，供公众和游客免费查询使用，由于能力有限，内容难免有错误遗漏之处，欢迎批评指正，以便更好服务公众和游客。若有版权、纠错、校对问题请联系yuyok2019@126.com。 </a>
					<a class="f" style="color:#999; font-style:italic; max-width:100%;padding:5px 5px; text-align:center;font-size:12px;" v-if="info"><p>编辑：{{info.Uptor}}</p><p>最后编辑时间：{{info.updated_at?info.updated_at.substr(0, 10):''}}</p></a>
					<a style="color:#7e7d7d; display:block;max-width:100%;padding:5px 5px;text-align:center;" v-html="region.Copyright"></a>
				</div>
			</div>
		</div>
</template>
<script>
export default {
  data(){
    return {
      
    }
  },
  components: {
  	
  },
  props: {
  	info: {
  		type: Object,
  		require: true
  	},
  	region: {
  		type: Object,
  		require: true
  	},
  },
  watch: {
  },
  methods: {
  		
  },
  created(){
  }
};

</script>
<style>
	.bjs{
		background-color: rgba(255, 255, 255, 0) !important;
		box-shadow: none !important;
		font-weight: bold!important;
		line-height: 1.6;
	}
	.panel-footer{
		background-color: none !important;
	}
	.f{
		display: flex;
		justify-content: center;
	}
	.f p:first-child{
		margin-right: 6%;
	}
</style>